import { render, staticRenderFns } from "./ed-section-state.component.vue?vue&type=template&id=036905d7&scoped=true&"
import script from "./ed-section-state.component.ts?vue&type=script&lang=ts&"
export * from "./ed-section-state.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-section-state.component.scss?vue&type=style&index=0&id=036905d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036905d7",
  null
  
)

export default component.exports